export const qiniuUploadUrl = 'https://up.qiniup.com'
export const qiniuImageURLPrefix = "https://img.senguo.cc/"

export const getQiniuImgUrl = (path: string, size: number = 100) => {
    return qiniuImageURLPrefix + path + '?imageView2/1/w/' + size
}
